import { Component, Input, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CuratedSpecialtiesService } from 'app/core/services/curated-specialties.service';

import { BlankValueDashComponent } from '../blank-value-dash/blank-value-dash.component';

@Component({
    selector: 'app-specialty-badges',
    templateUrl: './specialty-badges.component.html',
    styleUrls: ['./specialty-badges.component.scss'],
    imports: [BlankValueDashComponent]
})
export class SpecialtyBadgesComponent {
  private curatedSpecialtiesService = inject(CuratedSpecialtiesService);

  @Input() specialties: string[];
  @Input() showBlank = false;

  curatedSpecialties = toSignal(this.curatedSpecialtiesService.getActiveSpecialties(), {
    initialValue: new Set<string>(),
  });

  isCurated(specialty: string) {
    return this.curatedSpecialties().has(specialty.toLowerCase());
  }
}
